namespace $.$$ {
	
	$mol_style_define( $hyoo_dnd_parameter, {
		
		background: {
			color: $mol_theme.card,
		},
		
		Title: {
			padding: $mol_gap.text,
			flex: {
				grow: 1,
			},
		},
		
		Value: {
			padding: $mol_gap.text,
			color: $mol_theme.special,
			justify: {
				content: 'center',
			},
		},
		
	} )
	
}
